// Under the hood functionality
import React, { useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Styles
import './FontStyles.css'
import './modals/CommonModalStyles.css'

// Application Platform components
import NavigationBar from './navigation/NavigationBar'
import HomeRoute from './routes/home/HomeRoute';
import ApplicationModal from './modals/application/ApplicationModal';
import MenuModal from './modals/menu/MenuModal';
import ModalUnderlayer from './modals/ModalUnderlayer';


// Application Feature components
import Resume from '../features/routes/resume/Resume';

export default function App() {

  const [applicationModal, applicationModalOpened] = useState(false)
  const [menuModal, menuModalOpened] = useState(false)
  const [modalUnderlayer, modalUnderlayerOpened] = useState(false)

  return (
    <BrowserRouter>

      <main id="Main-Element" className='Main-Element'>
        <Routes>
          <Route exact path='/*' element={<HomeRoute />} />
          <Route exact path='/resume' element={<Resume />} />
        </Routes>
      </main>

      {modalUnderlayer &&
        (
          <ModalUnderlayer
            applicationModal={applicationModal}
            applicationModalOpened={applicationModalOpened}
            menuModal={menuModal}
            menuModalOpened={menuModalOpened}
            modalUnderlayer={modalUnderlayer}
            modalUnderlayerOpened={modalUnderlayerOpened}></ModalUnderlayer>
        )}

      {applicationModal &&
        (
          <ApplicationModal closeModal={applicationModalOpened} closeUnderlayer={modalUnderlayerOpened} />
        )}
      {menuModal &&
        (
          <MenuModal closeModal={menuModalOpened} closeUnderlayer={modalUnderlayerOpened} />
        )}

      <NavigationBar
        applicationModal={applicationModal}
        applicationModalOpened={applicationModalOpened}
        menuModal={menuModal}
        menuModalOpened={menuModalOpened}
        modalUnderlayer={modalUnderlayer}
        modalUnderlayerOpened={modalUnderlayerOpened}
      ></NavigationBar>

    </BrowserRouter>
  );
}

// CSS Classes naming and organizational convention: Name, Type (route or component), Element (type: NavigationButton, Header, Anchor, PTag, H1 etc), Characteristics (Animation, Color, Position, Dimensions, Shape) Status (Open or Closed), Effects (Flex, Spacing (margin, padding), (effecting inside components) These can be a variation of but a common type of style written in a common styles css file) Example:
// 6 kinds of classes: Name, Type, Element, Characteristics, Status, Effects

// Home-Route-Animation
// Home-Route-Colors
// Home-Route-Position
// Home-Route-Dimensions
// Home-Route-Flex
// Home-Route-Spacing
// Home-Route-Shape
// NavigationBar-HomeButton-Color
// NavigationBar-ModalButton-Color-Opened
// NavigationBar-ModalButton-Color-Closed
// NavigationBar-ModalButton-Animation-Opened
// NavigationBar-Button-Animation-Closed
// NavigationBar-Buttons-Dimensions

// Home-Route-NavigationButton-Dimensions
// Home-Route-NavigationButton p (element p is for the text label of the button)

// So far, status would be for buttons only that are used to open modals as my method is effecting animations or the colors of those buttons. Building an element Class: className="Home-Route-Animation Home-Route-Colors Home-Route-Position Home-Route-Dimensions Home-Route-Flex"

// Example of button class when the Modal is closed: className="Home-Route-NavigationButton-Color Home-Route-NavigationButton-Animation Home-Route-NavigationButton-Dimensions Home-Route-NavigationButton-Closed"

// // Example of a button class when the Modal is open: className="Home-Route-NavigationButton-Color Home-Route-NavigationButton-Animation Home-Route-NavigationButton-Dimensions Home-Route-NavigationButton-Opened"

// The text label on the button will say open by default if the modal default is closed (false) if using state to manage it's render, and the if statement will be used to check the const button.textContent = 'open' to then perform functions and class switches to activate css tyles to trigger certain animations or color changes of that button, eg, if the modal is closed the the button will be blue and the text will say open. When the modal is opened, then the button will be red and the text will say close

// My theory behind this convetion is to keep styles more dry, when considering media qeries for different screen sizes. For the most part, it seems dimsensions, flex and sometimes, position properties need to be changed so we can avoid duplicating animations, colors and if not changed, then positions.